'use strict';
window.FastClick = require('fastclick');
require('lazyload');
require('fancybox')(window.$);
require('../source/lib/velocity-animate');
require('../source/lib/velocity-animate/velocity.ui');
require('./utils');
require('./motion');
require('./affix');
require('./pisces');
require('./scrollspy');
require('./post-details');
require('./bootstrap');
require('./evanyou');
if (window.CONFIG.leancloud.enable) {
    require('./leancloud');
}


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 2
// module chunks = 0